import { fromModel, items, required, shape, stopOnFirstFailure, when, between, errorMessage } from '@totalsoft/pure-validations';
import { isNotEmpty, isPositiveOrZero, isValidDateFormat, valueAmong } from 'utils/simple-validations';
import { MaxDecimalPrecision, MinDecimalPrecision } from './constants';
import i18next from 'i18next';

export const insuranceConventionValidator = fromModel(item =>
  shape({
    productName: required,
    productCode: required,
    currencyId: required,
    insuranceAmountId: required,
    productPeriod: required,
    defaultProductPeriod:
      [
        required,
        valueAmong(
          item?.productPeriod?.map(x => Number(x)),
          i18next.t('InsuranceConventions.DefaultPeriodicityAmongPeriods')
        )
      ] |> stopOnFirstFailure,
    insuredAmountTypeId: required,
    roundInsuredAmount: [required, between(MinDecimalPrecision, MaxDecimalPrecision)] |> stopOnFirstFailure,
    roundInsuranceAmount: [required, between(MinDecimalPrecision, MaxDecimalPrecision)] |> stopOnFirstFailure,
    roundInsuranceRate: [required, between(MinDecimalPrecision, MaxDecimalPrecision)] |> stopOnFirstFailure,
    startDate: isValidDateFormat,
    endDate: isValidDateFormat
  })
);

export const insuranceConventionRiskValidator = shape({
  insuranceTypeId: required,
  riskTypeId: required
});

export const insuranceConventionConditionsValidator = fromModel(item =>
  shape({
    withTemplate: required,
    templateId: required |> when(item.withTemplate),
    template: shape({
      phrase: required |> when(!item.withTemplate),
      conditions: stopOnFirstFailure([
        isNotEmpty |> when(!item.withTemplate),
        items(
          shape({
            orderNo: required |> when(!item.withTemplate),
            paramId: required |> when(!item.withTemplate),
            operatorId: required |> when(!item.withTemplate)
          })
        )
      ])
    })
  })
);

export const insuranceConventionCommissionValidator = fromModel(() =>
  shape({
    insuranceTypeId: required,
    commission:
      [required, between(0, 100) |> errorMessage(i18next.t('Validations.Generic.PercentageBetweenZeroHundred'))] |> stopOnFirstFailure
  })
);

export const insuranceUsageGridValidator = fromModel(() =>
  shape({
    age: [required, isPositiveOrZero] |> stopOnFirstFailure,
    usagePercent:
      [required, between(0, 100) |> errorMessage(i18next.t('Validations.Generic.PercentageBetweenZeroHundred'))] |> stopOnFirstFailure,
    insurancePercent:
      [required, between(0, 100) |> errorMessage(i18next.t('Validations.Generic.PercentageBetweenZeroHundred'))] |> stopOnFirstFailure
  })
);

export const insuranceConventionDeductibleCostsValidator = fromModel(item =>
  shape({
    damageTypeId: required,
    deductibleCostPercent:
      [
        between(0, 100) |> errorMessage(i18next.t('Validations.Generic.PercentageBetweenZeroHundred')),
        (required |> when(item.deductibleCostAmount === null))
      ] |> stopOnFirstFailure,
    deductibleCostAmount: required |> when(item.deductibleCostPercent === null),
    currencyId: required
  })
);

export const insuranceConventionInsurerValidator = items(
  shape({
    editObject: shape({
      insurerId: required
    })
  })
);

export const insuranceConventionItemTypeValidator = shape({
  itemTypeId: required
});
